var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialReportOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 8.08366V18.917C21.6666 23.2503 20.5833 24.3337 16.2499 24.3337H9.74992C5.41659 24.3337 4.33325 23.2503 4.33325 18.917V8.08366C4.33325 3.75033 5.41659 2.66699 9.74992 2.66699H16.2499C20.5833 2.66699 21.6666 3.75033 21.6666 8.08366Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 6.45898H10.8333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.1923C13.9273 21.1923 14.6791 20.4405 14.6791 19.5132C14.6791 18.5858 13.9273 17.834 13 17.834C12.0726 17.834 11.3208 18.5858 11.3208 19.5132C11.3208 20.4405 12.0726 21.1923 13 21.1923Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialReportOtherIcon);
export default __webpack_public_path__ + "static/media/financial_report_other_icon.4b939b24729e63e65c4f1edf4c7b95da.svg";
export { ForwardRef as ReactComponent };